/* projects/portal/src/app/pages/help/help.component.css */
.help-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 16px 18px;
  text-decoration: none;
  display: block;
  transition: border-color 0.15s ease;
}
.help-card:hover {
  border-color: var(--primary-color);
}
.help-icon {
  color: var(--primary-color);
  margin-bottom: 8px;
}
.help-title {
  font-weight: 500;
  color: var(--ink);
  margin-bottom: 4px;
}
.help-body {
  font-size: 13px;
  color: var(--ink-soft);
  line-height: 1.45;
}
tr.row-you td {
  background: #fdf3e2;
  font-weight: 500;
}
.help-list {
  margin: 8px 0 0;
  padding-left: 20px;
  font-size: 13px;
  color: var(--ink-soft);
  line-height: 1.7;
}
/*# sourceMappingURL=help.component.css.map */
